import React from 'react';
import Icon from '../../../components/AppIcon';

const PrivacyPolicy = () => {
  const privacyData = {
    lastUpdated: '23 Septembre 2025',
    sections: [
      {
        title: '1. Collecte des Données',
        content: `Nous collectons les informations suivantes:
        • Données d'identification: nom, prénom, email, téléphone
        • Données de navigation: pages visitées, durée de session
        • Données de géolocalisation: pour les recherches de propriétés
        • Données de préférences: critères de recherche sauvegardés
        • Données d'interaction: avec les vidéos et contenus immersifs`
      },
      {
        title: '2. Utilisation des Données',
        content: `Vos données sont utilisées pour:
        • Fournir nos services de recherche immobilière
        • Organiser les rendez-vous avec les notaires partenaires
        • Personnaliser l'expérience utilisateur• Améliorer nos services par l'analyse statistique
        • Respecter nos obligations légales et réglementaires`
      },
      {
        title: '3. Conformité RGPD',
        content: `Conformément au RGPD, vous disposez des droits suivants:
        • Droit d'accès à vos données personnelles
        • Droit de rectification des informations inexactes
        • Droit à l'effacement ('droit à l'oubli')
        • Droit à la portabilité des données
        • Droit d'opposition au traitement`
      },
      {
        title: '4. Partage des Données',
        content: `Nous partageons vos données uniquement avec:
        • Nos notaires partenaires agréés (pour les rendez-vous)
        • Prestataires techniques sécurisés (hébergement, maintenance)
        • Autorités légales (si requis par la loi ivoirienne)
        • Jamais avec des tiers à des fins commerciales sans consentement`
      },
      {
        title: '5. Sécurité des Données',
        content: `Mesures de protection mises en place:
        • Chiffrement SSL/TLS pour toutes les transmissions
        • Serveurs sécurisés avec accès restreint
        • Authentification à double facteur pour les comptes administrateurs
        • Sauvegardes régulières et plans de récupération
        • Formation continue de notre équipe sur la sécurité`
      },
      {
        title: '6. Conservation des Données',
        content: `Durées de conservation:
        • Comptes utilisateurs actifs: durée d'utilisation + 3 ans
        • Données de navigation: 13 mois maximum
        • Communications client: 5 ans (obligations légales)
        • Données de transaction notariale: selon réglementation ivoirienne`
      }
    ]
  };

  return (
    <div className="p-8">
      <div className="flex items-center space-x-4 mb-8">
        <div className="w-12 h-12 bg-brand-gold/10 rounded-xl flex items-center justify-center">
          <Icon name="Shield" size={24} color="var(--color-brand-earth)" />
        </div>
        <div>
          <h2 className="font-heading font-bold text-2xl text-brand-earth">
            Politique de Confidentialité
          </h2>
          <p className="text-gray-600 text-sm">
            Dernière mise à jour: {privacyData?.lastUpdated}
          </p>
        </div>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-8">
        <div className="flex items-start space-x-3">
          <Icon name="CheckCircle" size={20} color="var(--color-green-600)" />
          <div>
            <p className="text-green-800 text-sm font-medium">
              KAPITALSTATES est conforme au RGPD et aux réglementations ivoiriennes sur la protection des données. 
              Vos informations sont protégées selon les plus hauts standards de sécurité.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-8">
        {privacyData?.sections?.map((section, index) => (
          <div key={index} className="border-l-4 border-brand-gold pl-6">
            <h3 className="font-heading font-semibold text-xl text-brand-earth mb-4">
              {section?.title}
            </h3>
            <div className="text-gray-700 leading-relaxed whitespace-pre-line">
              {section?.content}
            </div>
          </div>
        ))}
      </div>

      {/* Rights Management */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="p-6 bg-brand-earth/5 rounded-xl">
          <h3 className="font-heading font-semibold text-brand-earth mb-3 flex items-center space-x-2">
            <Icon name="UserCheck" size={20} color="var(--color-brand-earth)" />
            <span>Exercer vos Droits</span>
          </h3>
          <p className="text-gray-700 text-sm mb-4">
            Pour exercer vos droits RGPD ou modifier vos préférences de confidentialité:
          </p>
          <div className="text-sm space-y-2">
            <div className="flex items-center space-x-2">
              <Icon name="Mail" size={14} color="var(--color-brand-earth)" />
              <span>privacy@kapitalstates.com</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={14} color="var(--color-brand-earth)" />
              <span>Réponse sous 30 jours</span>
            </div>
          </div>
        </div>

        <div className="p-6 bg-brand-earth/5 rounded-xl">
          <h3 className="font-heading font-semibold text-brand-earth mb-3 flex items-center space-x-2">
            <Icon name="AlertTriangle" size={20} color="var(--color-brand-earth)" />
            <span>Signaler un Incident</span>
          </h3>
          <p className="text-gray-700 text-sm mb-4">
            En cas de problème de sécurité ou de confidentialité:
          </p>
          <div className="text-sm space-y-2">
            <div className="flex items-center space-x-2">
              <Icon name="Phone" size={14} color="var(--color-brand-earth)" />
              <span>+225 01 41 07 02 71</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Zap" size={14} color="var(--color-brand-earth)" />
              <span>Réponse immédiate 24/7</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;